// iOS Safari 兼容性 polyfills - 必須在其他導入之前
import "./utils/polyfills";

const _origGetContext = HTMLCanvasElement.prototype.getContext;
HTMLCanvasElement.prototype.getContext = function (type, attrs) {
	if (type === "2d") {
		attrs = { willReadFrequently: true, ...attrs };
	}
	return _origGetContext.call(this, type, attrs);
};

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { GlobalProvider } from "./context/GlobalContext";
import { EarthquakeProvider } from "./context/EarthquakeContext";
import { BellNotificationProvider } from "./context/BellNotificationContext";
import { NotificationProvider } from "./context/NotificationContext";
import { RpmProvider } from "./context/RpmContext";
import AppWrapper from "./App";
import "./i18n";
import store from "./store";
// bootstrap 全域樣式（grid/reboot）必須在進入點載入：
// lazy 化後若只由個別頁面匯入，其他頁的 Row/Col grid（如 FFT 3D 三欄）
// 要等造訪該頁才生效，造成載入順序依賴的跑版（v5.17.x 迴歸教訓）。
// 置於 index.scss 之前，讓專案自訂樣式可覆蓋 bootstrap。
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";

// **新建 EarthquakeWrapper 組件**
function EarthquakeWrapper({ children }) {
	const isIntranetUsed = process.env.Intranet;

	// **只有在 `isIntranetUsed為false` 時才包裹 `EarthquakeProvider`**
	return isIntranetUsed == "true" ? (
		children
	) : (
		<EarthquakeProvider>{children}</EarthquakeProvider>
	);
}

const RootApp = () => {
	return (
		<EarthquakeWrapper>
			<BellNotificationProvider>
				<NotificationProvider>
					<RpmProvider>
						<GlobalProvider>
							<Provider store={store}>
								<AppWrapper />
							</Provider>
						</GlobalProvider>
					</RpmProvider>
				</NotificationProvider>
			</BellNotificationProvider>
		</EarthquakeWrapper>
	);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootApp />);
